/**
 * Created by Pawel Grzyb 01.04.2018
 *
 * Main page.
 */

import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-page',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.css']
})
export class MainPageComponent implements OnInit {

  constructor() {}

  ngOnInit() {}
}
